<!--suppress TypeScriptUnresolvedFunction, TypeScriptUnresolvedVariable -->
<div fxLayout="column" class="iec61850-config-container">
    <div fxLayout="row" fxLayoutAlign="center" class="mb-16">
        <span>{{'Type'|i18n}}: <strong>{{cfg.type|connectorType}}</strong></span>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="iec61850-form">
        </form>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Hosts'}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-host-button"
                (click)="onClickAddHost()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add host'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedHosts|async as hosts">
            <ng-container *ngIf="hosts">
                <div *ngFor="let host of hosts.data; trackBy: trackByHostId"
             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
            <div fxLayoutAlign="end" fxFlex="grow">
                <em>{{host.hostId}}</em>
            </div>
            <form novalidate [formGroup]="host.form" fxLayoutAlign="center" fxFlex="shrink" fxLayoutGap="0.5rem"
                  class="host-form">
                <mat-form-field>
                    <input matInput placeholder="{{'Host'|i18n}}" formControlName="host">
                    <mat-error *ngIf="!host.form.controls.host.valid">
                        {{'Invalid host'|i18n}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="port-field">
                    <input matInput placeholder="{{'Port'|i18n}}" formControlName="port" type="number">
                    <mat-error *ngIf="!host.form.controls.port.valid">
                        {{'Invalid port'|i18n}}
                    </mat-error>
                </mat-form-field>
            </form>
            <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                <button class="operation-button" [title]="'Rename host'|i18n"
                        (click)="onClickRenameHost(host.hostId)">
                    <app-icon name="fal-edit"></app-icon>
                </button>
                <button class="operation-button warn" [title]="'Remove host'|i18n"
                        (click)="onClickDeleteHost(host.hostId)">
                    <app-icon name="fal-trash-alt"></app-icon>
                </button>
            </div>
        </div>
        </ng-container>
        <mat-paginator #hostsPaginator app-paginator class="iec61850-paginator"
                       [ngClass]="{'collapsed': !hosts || hosts.total === 0}"
                       [length]="hosts?.total" [pageSize]="PAGE_SIZE"
                       [pageSizeOptions]="PAGE_SIZES">
        </mat-paginator>
        </ng-container>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Devices'|i18n}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-device-button"
                (click)="onClickAddDevice()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add device'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedDevs|async as devs">
            <ng-container *ngIf="devs">
                <div *ngFor="let dev of devs.data; trackBy: trackByDevId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{dev.devId}}</em>
                    </div>
                    <div fxLayoutAlign="center" fxFlex="shrink" fxLayoutGap="0.5rem">
                        <form novalidate [formGroup]="dev.form" fxLayoutGap="0.5rem" class="device-form">
                            <mat-form-field fxFlex="grow">
                                <mat-select placeholder="{{'Host'|i18n}}" formControlName="hostId">
                                    <mat-option *ngFor="let host of hosts; trackBy: trackByHostId"
                                                [value]="host.hostId">
                                        {{host.hostId}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!dev.form.controls.hostId.valid">
                                    {{'Invalid host'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field fxFlex="grow">
                                <input matInput placeholder="{{'Reference'|i18n}}" formControlName="reference"
                                       [title]="'Multiple references are comma-separated'|i18n">
                                <mat-error *ngIf="dev.form.controls.reference.hasError('empty')">
                                    {{'Invalid reference'|i18n}}
                                </mat-error>
                                <mat-error *ngIf="dev.form.controls.reference.hasError('bad_expression')">
                                    {{'Multiple references need expression'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="uom-field">
                                <input matInput placeholder="{{'UoM'|i18n}}" formControlName="uom"
                                       [title]="'Unit of measure'|i18n">
                                <mat-error *ngIf="!dev.form.controls.uom.valid">
                                    {{'Invalid UoM'|i18n}}
                                </mat-error>
                            </mat-form-field>
                        </form>
                        <div fxFlexAlign="center">
                            <button mat-stroked-button class="polling-policy-btn" [title]="'Polling policy'|i18n"
                                    (click)="onClickDevicePollingPolicy(dev.devId)">
                        <span class="polling-policy-text">
                            <app-icon name="fal-stopwatch"></app-icon>&nbsp;
                            {{cfg.devices[dev.devId]|pollingPolicy}}
                        </span>
                            </button>
                        </div>
                    </div>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [title]="'Advanced settings'|i18n"
                                (click)="onClickDeviceAdvancedSettings(dev)">
                            <app-icon name="fal-tools"></app-icon>
                        </button>
                        <button class="operation-button" [title]="'Rename device'|i18n"
                                (click)="onClickRenameDevice(dev.devId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove device'|i18n"
                                (click)="onClickDeleteDevice(dev.devId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #devsPaginator app-paginator class="iec61850-paginator"
                           [ngClass]="{'collapsed': !devs || devs.total === 0}"
                           [length]="devs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
</div>

<ng-template #addHost let-data>
    <h1 mat-dialog-title>{{'Add host'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameHost let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['hostId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="rename-host">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs">
            {{'Devices connected to {0}'|i18n:data['hostId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs">
            {{'No devices connected to {0}'|i18n:data['hostId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteHost let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['hostId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="delete-host">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['hostId']}}</span>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs mt-16">
            {{'Devices connected to {0}'|i18n:data['hostId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs mt-16">
            {{'No devices connected to {0}'|i18n:data['hostId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #addDevice let-data>
    <h1 mat-dialog-title>{{'Add device'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field>
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['devId']}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #advancedDeviceSettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <mat-form-field>
                <mat-select placeholder="{{'Data type'|i18n}}" formControlName="dataType">
                    <mat-option *ngFor="let dataType of IEC61850_DATA_TYPES" [value]="dataType">
                        {{dataType|iec61850DataType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.dataType.valid">
                    {{'Invalid data type'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Reference type'|i18n}}" formControlName="refType">
                    <mat-option *ngFor="let refType of IEC61850_REF_TYPES" [value]="refType">
                        {{refType|iec61850RefType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.refType.valid">
                    {{'Invalid reference type'|i18n}}
                </mat-error>
            </mat-form-field>
            <span class="expression-label">
                {{'Expression'|i18n}}
            </span>
            <app-expression-editor formControlName="expression"
                                   [features]="data['features']">
            </app-expression-editor>
            <span *ngIf="data['form'].controls.expression.hasError('bad_expression')" class="expression-error">
                {{'Invalid expression for multi-reference device'|i18n}}
            </span>
        </form>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1rem" class="mt-8">
            <span *ngIf="data['references'].length" class="references">
                {{'References'|i18n}}: {{data['references'].join(', ')}}
            </span>
            <app-icon name="fal-question-circle" class="expression-help"
                      [matTooltip]="EXPRESSION_HELP|i18n"
                      matTooltipClass="fs-1">
            </app-icon>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
